import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home'
import ITSolutions from '../views/IT'
import SecuritySolutions from '../views/Security'
import News from '../views/News'
import About from '../views/About'
import Products from '../views/Products'
import Careers from '../views/About/Subpage/Careers'
import CareersDetail from '../views/About/Subpage/Careers/detail'
import ProductDetail from '../views/Products/products_deatil'
import NewsDetail from '../views/News/new_detail'
import ITDetail from '../views/IT/it_detail'
import SecurityDetail from '../views/Security/security_detail'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/it',
    name: 'ITSolutions',
    component: ITSolutions
  },
  {
    path: '/security',
    name: 'SecuritySolutions',
    component: SecuritySolutions
  },
  {
    path: '/it/detail',
    name: 'ITDetail',
    component: ITDetail
  },
  {
    path: '/security/detail',
    name: 'SecurityDetail',
    component: SecurityDetail
  },
  {
    path: '/news',
    name: 'News',
    component: News
  },
  {
    path: '/news/detail',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/products',
    name: 'Products',
    component: Products
  },
  {
    path: '/products/detail',
    name: 'ProductDetail',
    component: ProductDetail
  },
  {
    path: '/about/careers',
    name: 'Careers',
    component: Careers
  },
  {
    path: '/about/careers/detail',
    name: 'CareersDetail',
    component: CareersDetail
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），则使用保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 如果路由包含锚点
    if (to.hash) {
      // 对于产品中心页面，如果 hash 是产品系统的锚点，且是从其他页面跳转过来的，滚动到 products-main 位置
      if (to.path === '/products' && (to.hash === '#big-data-platform' || to.hash === '#application-center' || to.hash === '#operation-center') && from.path !== to.path) {
        return new Promise((resolve) => {
          setTimeout(() => {
            const productsMain = document.querySelector('.products-main')
            if (productsMain) {
              const offsetTop = productsMain.offsetTop - 70 // 减去固定导航栏高度
              resolve({
                top: offsetTop,
                behavior: 'smooth'
              })
            } else {
              resolve({ top: 0, behavior: 'smooth' })
            }
          }, 100)
        })
      }
      // 对于产品中心页面，如果只是 hash 变化（在同一页面内），不滚动，由组件自己控制
      if (to.path === '/products' && from.path === '/products') {
        return false // 阻止默认滚动行为
      }
      // 其他情况，滚动到锚点元素
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
    // 否则滚动到页面顶部
    return { top: 0, behavior: 'smooth' }
  }
})

export default router

